var map = {
	"./L12.png": "8bbf",
	"./L6.png": "0469",
	"./L7.png": "6af1",
	"./L8.png": "32c7",
	"./R5.png": "db5d",
	"./R50.png": "1801",
	"./R6.png": "7a52",
	"./R60.png": "ab39",
	"./S1.png": "8dd5",
	"./S2.png": "54c9",
	"./S3.png": "dff8",
	"./S33.png": "a655",
	"./S4.png": "52de",
	"./S5.png": "0b7d",
	"./S55.png": "8eda",
	"./S6.png": "f576",
	"./S7.png": "47e2",
	"./S8.png": "3927",
	"./S9.png": "3812"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ac7";